export default "__VITE_ASSET__92ae37c5__"